import { render, staticRenderFns } from "./CustomGenericFilter.vue?vue&type=template&id=6b5d31b4"
import script from "./CustomGenericFilter.vue?vue&type=script&lang=js"
export * from "./CustomGenericFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports